import React from "react";
import Grid from '@material-ui/core/Grid';
import {ContentState, convertToRaw} from "draft-js";
import MUIRichTextEditor from 'mui-rte'

import classes from "./Message.module.css";
import RollMessage from "./RollMessage"
import Portrait from "../../../../../hooks/Portrait/Portrait"

export default function Message({ timestamp, character, message, meta }) {

  // Prepare mui-rte ContentState if we're happy were not dealing with a macro message
  const draftJsContent = (message) => {
    let contentState = '';

    const createContentFromText = () => {
      return JSON.stringify(convertToRaw(ContentState.createFromText(message)));
    }

    try {
      let content = JSON.parse(message);
      contentState = (content !== '') ? message : createContentFromText(message);
    } catch(e) {
      contentState = createContentFromText(message);
    }

    return (
      <MUIRichTextEditor value={contentState} readOnly={true} toolbar={false}/>
    )
  }

  let messageContent = meta.diceRoll
    ? RollMessage(message, meta)
    : draftJsContent(message);
    

  return (
    <Grid container spacing={0}
      direction="row">
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <div className={classes.message}>
          <div className={classes.avatarContainer}>
            <div className={classes.avatar}>
        
              {/* <Avatar src={character.characterPortrait}  /> */}
              <Portrait character={character}></Portrait>
            
            </div>
          </div>
          <div className={classes.message__info}>
            <h4>
              {character.characterName}
            </h4>
            {messageContent}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
